import PureHeatMap from './AsyncHeatMap';
import { connect } from 'react-redux';
import { questionKey } from '../response/reducer';
import * as actions from './actions';
import raf from 'raf';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  const {
    completionStatus,
    countdownStatus,
    currentRow,
    errorMessages,
    isValid,
    markers,
    markerValids,
    notes,
    rows,
    rowValids,
    selected,
    timer,
    times,
    startTime,
    name,
  } = question;

  const attachment = state.attachments[question.id];
  const thumbUrl = attachment ? attachment.large_url : null;
  const dimensions = attachment ? attachment.dimensions : {};
  const url = attachment ? attachment.full_url : null;
  const allowNotes = ownProps._type === 'Survey::StickyNote';
  const timed = ownProps._type === 'Survey::TimedHeatMap';
  const isRowComplete = rows[currentRow]
    ? rows[currentRow].keys.length >= ownProps.min_number_of_fields
    : false;
  const isFinalRow = currentRow === rows.length - 1;

  return {
    allowNotes,
    completionStatus,
    countdownStatus,
    currentRow,
    errorMessages,
    dimensions,
    isFinalRow,
    isRowComplete,
    isValid,
    markers,
    markerValids,
    name,
    notes,
    rowValids,
    selected,
    startTime,
    thumbUrl,
    timed,
    timer,
    times,
    timestamps: rows,
    url,
  };
};

const mapDispatchToProps = (
  dispatch,
  { _type, id: questionId, min_number_of_fields: min, number_of_fields: max }
) => ({
  onLayerClick: ({ coords, event, isFull, rowIndex, selected, timestamp }) => {
    if (selected || isFull) {
      event.stopPropagation();
      return dispatch(actions.deselect(questionId));
    } else {
      dispatch(
        actions.addMarker({
          min,
          max,
          rowIndex,
          ...coords,
          questionId,
          timestamp,
        })
      );
    }
  },
  onRemoveClick: (rowIndex, timestamp) =>
    dispatch(actions.removeMarker(rowIndex, timestamp, questionId)),
  onMarkerClick: (timestamp, rowIndex) =>
    dispatch(actions.selectMarker(timestamp, rowIndex, questionId)),
  onNoteCloseClick: () => dispatch(actions.deselect(questionId)),
  onNoteChange: (timestamp, value) =>
    dispatch(actions.updateNote(timestamp, value, questionId)),
  onRowButtonClick: rowIndex => e => {
    e && e.preventDefault();
    dispatch(actions.selectRow(rowIndex, questionId));
  },
  setDomain: ({ width, height }) =>
    dispatch(actions.setDomain({ width, height }, questionId)),
  beginCountdown: () => {
    if (_type === 'Survey::TimedHeatMap') {
      dispatch(actions.beginCountdown(questionId));
      const timeout = 1000;
      /* istanbul ignore next */
      const cb = () =>
        raf(() => dispatch(actions.count(cb, timeout, questionId)));
      window.setTimeout(cb, timeout);
    } else {
      dispatch(actions.open(questionId));
    }
  },
  onClose: () => dispatch(actions.close(questionId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PureHeatMap);
